import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { isGlobal } from "@/lib/access";

export function useTenants() {
  const { user } = useAuth();
  const enabled = (user?.permissions || []).includes("*") || isGlobal(user, "settings", "view");
  return useQuery({
    queryKey: ["tenants"],
    queryFn: async () => (await http.get("/tenants")).data,
    enabled,
    staleTime: 60_000,
  });
}
